
import { url } from '@tencent/wphk-base-utils';
import aegis from '../../lib/aegis';
import { getStartTime } from '../../lib/aegis/utils';
import LoginReport from './login-report';
import { LoginAccessType } from './login-type-report/business';

// sessionStorage存储标识，用于标识微信客户端点击时间是否已上报（这里没有必要区分业务)
const REPORTED_FLAG_KEY = 'wx_click_time_firstScreenTiming_reported';

export default class WxClientClickTimeReport {
  /** 业务标识 */
  business = '';
  /** sessionStorage存储标识，用于标识微信客户端点击时间是否已上报（这里没有必要区分业务） */
  cacheKey = 'wx_click_time_reported';
  loginReport: LoginReport;
  constructor(business: string) {
    this.business = business;
    this.loginReport = new LoginReport(business);
  }
  /**  微信点击九宫格信息 */
  get wxClientClickInfo() {
    const clickTime = parseInt(url.getUrlParam('wx_client_click_time') || '0', 10);
    const renderOpt = url.getUrlParam('wx_client_render_opt') || '';
    if (clickTime > 0 && ['0', '1'].includes(renderOpt)) {
      return {
        clickTime,
        isPreRender: renderOpt === '1',
      };
    }
    return null;
  }
  /** 微信webview是否已开启预渲染进程 */
  get isPreRender() {
    return this.wxClientClickInfo?.isPreRender || false;
  }
  /** 检测是否已上报微信点击九宫格测速数据 */
  checkIsReported() {
    return sessionStorage.getItem(REPORTED_FLAG_KEY) === '1';
  }
  /** 存储测速已上报标记 */
  saveIsReported() {
    sessionStorage.setItem(REPORTED_FLAG_KEY, '1');
    return this.checkIsReported();
  }

  /** 上报从九宫格点击到页面启动耗时 */
  report(firstScreenTiming: number, loginType: LoginAccessType) {
    try {
      const isReported = this.checkIsReported();
      const wxClickInfo = this.wxClientClickInfo;
      if (!wxClickInfo || isReported) {
        return;
      }
      // 先存储已上报状态，这里再立即获取存储成功结果，防止sessionStorage存失败了，
      // 不支持sessionStorage时为了防止数据不准确，这类数据不上报
      if (!this.saveIsReported()) return;

      this.reportNavStartDuration(loginType);
      this.reportFirstScreenDuration(firstScreenTiming, loginType);
    } catch (error) {
    }
  }

  /**
   *  上报从微信点击九宫格图标到webview启动导航所耗费时间
   * @param loginType
   * @returns
   */
  reportNavStartDuration(loginType?: LoginAccessType) {
    const wxClickInfo = this.wxClientClickInfo!;
    const loginReportInfo = this.loginReport.getLoginReportInfo();
    let duration = getStartTime() - wxClickInfo.clickTime;
    if (loginType === LoginAccessType.auth) {
      // 1、有loginReportInfo信息，说明是活动页面前端登陆，此时需要取登陆前的页面启动时间来计算
      // 2、无loginReportInfo信息，说明是模版页登陆，由于无法获取到页面首次启动时间，所以不做上报
      duration = loginReportInfo ? loginReportInfo.cacheTiming.navigationStart - wxClickInfo.clickTime : 0;
    }
    if (duration > 0) {
      aegis.reportTime('wxClickDuration', duration);
    }
  }

  /**
   * 上报从微信点击九宫格图标到首页渲染完成所耗费时间
   * @param firstScreenTiming
   * @param loginType
   */
  reportFirstScreenDuration(firstScreenTiming: number, loginType?: LoginAccessType) {
    const wxClickInfo = this.wxClientClickInfo!;
    const duration = getStartTime() + firstScreenTiming - wxClickInfo.clickTime;
    if (duration) {
      switch (loginType) {
        case LoginAccessType.auth:
          // 上报从微信点击九宫格->auth2登录->页面渲染总耗时
          if (url.getUrlParam('_stk')) { // 上报token + auth的首屏渲染时长
            aegis.reportTime('wxClickBothLoginFirstScreenTiming', duration);
          } else {
            aegis.reportTime('wxClickLoginFirstScreenTiming', duration);
          }
          break;
        case LoginAccessType.token:
          // 上报从微信点击九宫格->token登录->页面渲染总耗时
          aegis.reportTime('wxClickTokenLoginFirstScreenTiming', duration);
          break;
        default:
          // 上报从微信点击九宫格->页面渲染总耗时
          aegis.reportTime('wxClickFirstScreenTiming', duration);
          break;
      }
    }
  }
}


